import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PracticeAreas } from './components/PracticeAreas';
import { AttorneyProfile } from './components/AttorneyProfile';
import { Testimonials } from './components/Testimonials';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <PracticeAreas data-id="element-4" />
        <AttorneyProfile data-id="element-5" />
        <Testimonials data-id="element-6" />
        <ContactSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}